import { Tag, Text } from "@zapier/design-system";
import { AiSparkle } from "../../AiSparkle";
import styles from "./ModifyPromptSidebarHeader.module.css";

export function ModifyPromptSidebarHeader() {
  return (
    <>
      <div className={styles.divider} />
      <div className={styles.header}>
        <AiSparkle />
        <Text type="SectionHeader" color="GrayWarm10">
          Modify prompt
        </Text>
        <Tag size="small" variant="simple">
          Beta
        </Tag>
      </div>
    </>
  );
}
